/* ==========================================================================
   VIBEE — product card image slider
   Save as: assets/vibee-card-slider.js

   One delegated listener set for the whole page instead of a script per card,
   so a 48-product grid costs the same as a single card. Works with cards
   injected later by collection filtering, pagination or infinite scroll.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__vibeeCardSlider) return;
  window.__vibeeCardSlider = true;

  var SLIDER = '[data-vibee-slider]';

  function track(slider) {
    return slider.querySelector('[data-vibee-track]');
  }

  function count(slider) {
    var t = track(slider);
    return t ? t.children.length : 0;
  }

  function render(slider, index) {
    var t = track(slider);
    var n = count(slider);
    if (!t || n < 2) return;

    index = ((index % n) + n) % n; // wrap both ways

    t.style.transform = 'translate3d(-' + index * 100 + '%,0,0)';
    slider.dataset.index = index;

    var dots = slider.querySelectorAll('[data-vibee-dot]');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }

    // Slides are lazy. Warm the neighbours so a click never lands on a blank
    // frame while the browser is still fetching.
    [index, index + 1, index - 1].forEach(function (k) {
      var img = t.children[((k % n) + n) % n];
      if (img && img.loading === 'lazy' && !img.complete) img.loading = 'eager';
    });
  }

  function move(slider, delta) {
    render(slider, (parseInt(slider.dataset.index, 10) || 0) + delta);
  }

  /* ---------- Arrows and dots ---------- */
  document.addEventListener('click', function (e) {
    var btn =
      e.target.closest &&
      e.target.closest('[data-vibee-prev],[data-vibee-next],[data-vibee-dot]');
    if (!btn) return;

    var slider = btn.closest(SLIDER);
    if (!slider) return;

    // The card is wrapped in links; never let one fire.
    e.preventDefault();
    e.stopPropagation();

    // Clicking focuses the button in most browsers, which would keep the
    // controls visible after the cursor leaves. Drop focus immediately.
    if (btn.blur) btn.blur();

    if (btn.hasAttribute('data-vibee-dot')) {
      render(slider, parseInt(btn.getAttribute('data-vibee-dot'), 10));
    } else {
      move(slider, btn.hasAttribute('data-vibee-next') ? 1 : -1);
    }
  });

  /* ---------- Snap back to the main image when the cursor leaves ---------- */
  document.addEventListener(
    'mouseleave',
    function (e) {
      var el = e.target;
      if (!el || el.nodeType !== 1 || !el.matches) return;
      if (!el.matches('.vibee-card-wrapper')) return;

      var slider = el.querySelector(SLIDER);
      if (slider && slider.dataset.index !== '0') render(slider, 0);
    },
    true // mouseleave does not bubble
  );

  /* ---------- Swipe ---------- */
  var startX = null;
  var startY = null;
  var active = null;

  document.addEventListener(
    'touchstart',
    function (e) {
      var slider = e.target.closest && e.target.closest(SLIDER);
      if (!slider || count(slider) < 2) return;

      // Inside a horizontally scrolling rail the native scroll owns the
      // sideways gesture. Flipping card images there fights the carousel.
      if (slider.closest('.vibee-fc-rail, .vibee-rail')) return;
      startX = e.changedTouches[0].clientX;
      startY = e.changedTouches[0].clientY;
      active = slider;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (!active || startX === null) return;

      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;

      // Horizontal intent only. Without the dy check, scrolling the page
      // vertically would flip card images by accident. Inside a carousel
      // section the rail keeps its own swipe because that listener sits on a
      // different element and this one only fires on a clear sideways drag.
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        move(active, dx < 0 ? 1 : -1);
      }

      startX = startY = active = null;
    },
    { passive: true }
  );
})();